import { WORLD_MAP_SIZE } from "./worldMapSvg";

export const GLOBE_REGIONS = [
  { id: "india", label: "India", lat: 21, lng: 78, color: "#18a67f", markerScale: 1.35 },
  { id: "uae", label: "UAE", lat: 24, lng: 54, color: "#f79839", markerScale: 1 },
  { id: "south-africa", label: "South Africa", lat: -28, lng: 25, color: "#f79839", markerScale: 1 },
];

export const GLOBE_REGION_BY_ID = Object.fromEntries(
  GLOBE_REGIONS.map((r) => [r.id, r]),
);

export function latLngToMapXY(lat, lng, size = WORLD_MAP_SIZE) {
  return {
    x: ((lng + 180) / 360) * size.width,
    y: ((90 - lat) / 180) * size.height,
  };
}
